import { render, staticRenderFns } from "./vueCarouselProjects.vue?vue&type=template&id=1967e8f4&scoped=true&"
import script from "./vueCarouselProjects.vue?vue&type=script&lang=ts&"
export * from "./vueCarouselProjects.vue?vue&type=script&lang=ts&"
import style0 from "./vueCarouselProjects.vue?vue&type=style&index=0&id=1967e8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967e8f4",
  null
  
)

export default component.exports